import PropTypes from "prop-types";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

// Shared tooltip wrapper for consistent delays and styling
export default function Tooltip({ children, content, delay = 100 }) {
    return (
        <TooltipPrimitive.Provider delayDuration={delay} skipDelayDuration={0}>
            <TooltipPrimitive.Root>
                <TooltipPrimitive.Trigger asChild>
                    {children}
                </TooltipPrimitive.Trigger>
                <TooltipPrimitive.Portal>
                    <TooltipPrimitive.Content
                        side="top"
                        align="center"
                        sideOffset={6}
                        avoidCollisions
                        collisionPadding={8}
                        forceMount
                        className="z-50 w-max max-w-xs sm:max-w-sm flex flex-col gap-1 rounded-md bg-gray-900/95 px-3 py-2 text-xs text-white shadow-md border border-cyan-400/20 drop-shadow-[0_0_6px_rgba(34,211,238,0.6)]"
                    >
                        {content}
                        <TooltipPrimitive.Arrow className="fill-gray-900" />
                    </TooltipPrimitive.Content>
                </TooltipPrimitive.Portal>
            </TooltipPrimitive.Root>
        </TooltipPrimitive.Provider>
    );
}

Tooltip.propTypes = {
    children: PropTypes.node.isRequired,
    content: PropTypes.node.isRequired,
    delay: PropTypes.number,
};
